import { render, staticRenderFns } from "./organizationList.vue?vue&type=template&id=1fec3eb3&scoped=true"
import script from "./organizationList.vue?vue&type=script&lang=js"
export * from "./organizationList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fec3eb3",
  null
  
)

export default component.exports